import * as types from '../../../actions';

const initialState = {
  items: [],
  status:0,
  totalPage:0,
  numRows:0,
  item:{
      id:'',
      name:'',
      rate:''
  },
  activity:'',
  count:'',
  errorData:'',
  subactivity:''   
};

export default function(state = initialState, action) {
  const response = action.response;
  let timeVar = '~~'+Date.now(); 

  switch(action.type) {
        case types.PAY_LEVELS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.PAY_LEVELS_LIST_SUCCESS,
                    subactivity:types.PAY_LEVELS_LIST_SUCCESS+timeVar,
                    numRows:response.data.length,
                };
            }else{
                return {
                    ...state,
                    activity:types.PAY_LEVELS_LIST_ERROR,
                    subactivity:types.PAY_LEVELS_LIST_SUCCESS+timeVar,
                    status: response.status,                                 
                };
            }      

        case types.PAY_LEVELS_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.PAY_LEVELS_ADD_SUCCESS,
                }      
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity:types.PAY_LEVELS_ADD_ERROR,
                }    
            } 
      
        case types.PAY_LEVELS_EDIT_SUCCESS: 
            if(response.status===200){ 
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.level_name,
                        rate:response.data.pay_rate_bonus,
                    },
                    status: response.status,
                    activity:types.PAY_LEVELS_EDIT_SUCCESS,               
                }
            }else{
                return {
                    ...state,                    
                    status: response.status,
                    activity:types.PAY_LEVELS_EDIT_ERROR,               
                }
            }          

        case types.PAY_LEVELS_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.PAY_LEVELS_UPDATE_SUCCESS,         
                }    
            }else{
                return {
                    ...state,   
                    errorData: response.data,
                    status: response.status,
                    activity:types.PAY_LEVELS_UPDATE_ERROR,         
                }   
            }
                          
        case types.PAY_LEVELS_DELETE_SUCCESS:
            const id = response.data.id;       
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),             
                    status: response.status,
                    activity:types.PAY_LEVELS_DELETE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.PAY_LEVELS_DELETE_ERROR,   
                    errorData: response.data
                }
            }           

        case types.CLEAR:
            return {
                ...state,
                item:{
                  id:'',
                  name: '',
                  certificateDetails:'',
                  certificateRequired:false
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
  }
};